import '../css/App.css';

import * as React from 'react';
import { Provider } from 'react-redux';

import { Route, Switch } from 'react-router-dom';

import { ConnectedRouter } from 'connected-react-router';
import Loading from '../../Loading/Loading';

import DownloadInformer from '../../DownloadInformer/DownloadInformer';

import ProtectedRoute from './ProtectedRouter';
import AdminRoute from './AdminRouter';
import AgronomistRoute from './AgronomistRouter';
import SuperUserRoute from './SuperUserRouter';
import UserRoute from './UserRouter';

import AdminPageView from '../../Admin/AdminPageView';
import Editor from '../../Editor';
import HomePageView from '../../Home/HomePageView';
import AgronomistPageView from '../../Agronomist/AgronomistPageView';
import ResultView from '../../Editor/components/Result/ResultView';
import LandingPage from '../../LandingPage';
import ReLogin from '../../ReLogin'
import Login from '../../Login';
import Wizard from '../../Wizard';
import '../../../lib/axiosConfig';
import configureStore, { history } from '../../../stores/store';
import SuperUserPageView from '../../SuperUser/SuperUserPageView';
import CreateProductLandingPage from '../../CreateProductLandingPage';
import ManageAgronomyReferenceSheets from '../../SuperUser/components/ManageAgronomyReferenceSheets'
import ManageProductLogos from '../../SuperUser/components/ManageProductLogos'
import ManageBrandings from '../../SuperUser/components/ManageBrandings'
import ManageComplimentaryLogos from '../../SuperUser/components/ManageComplimentaryLogos'
import ManageCovers from '../../SuperUser/components/ManageCovers'
import ManageCropCoverImages from '../../SuperUser/components/ManageCropCoverImages'
import ManageDisclaimers from '../../SuperUser/components/ManageDisclaimers'
import ManageFillerImages from '../../SuperUser/components/ManageFillerImages';
import ManagePostcardImages from '../../SuperUser/components/ManagePostcardImages';
import ManagePosterImages from '../../SuperUser/components/ManagePosterImages';
import ManageFullPageCatalogImages from '../../SuperUser/components/ManageFullPageCatalogImages'
import ManageSeedDividers from "../../SuperUser/components/ManageSeedDividers";
import ManageShelfDividers from "../../SuperUser/components/ManageShelfDividers";
import ManageSeedIcons from "../../SuperUser/components/ManageSeedIcons";
import ManageTaglines from '../../SuperUser/components/ManageTaglines'
import ManageTechSheets from '../../SuperUser/components/ManageTechSheets'
import BatchDownloadTechSheets from '../../BatchDownloads/BatchDownloadTechSheets'
import CreateProductTemplatePicker from '../../CreateProductWizard/CreateProductTemplatePicker'

import {saveNavigationRoute} from '../../../actions/actions';
import CreateProductModal from "../../Modals/CreateProductModal/CreateProductModal";

const store = configureStore();
class App extends React.Component {
  render() {
    return (
      <Provider store={store} >
        <ConnectedRouter history={history}>
          <div className="App">
            <Switch>
              <Route path="/ReLogin" component={ReLogin} />
              <Route path="/Login" component={Login} />
              <ProtectedRoute path="/LandingPage" component={LandingPage} saveNavigationRoute={saveNavigationRoute} />
              <ProtectedRoute path="/CreateProductLandingPage"  component={CreateProductLandingPage} saveNavigationRoute={saveNavigationRoute}/>
              <ProtectedRoute path="/Wizard" component={Wizard} saveNavigationRoute={saveNavigationRoute} />
              <ProtectedRoute path="/Editor" component={Editor}  saveNavigationRoute={saveNavigationRoute} />
              <ProtectedRoute path="/Result" component={ResultView}  saveNavigationRoute={saveNavigationRoute} />
              <ProtectedRoute path="/CreateProductTemplatePicker" component={CreateProductTemplatePicker} saveNavigationRoute={saveNavigationRoute}/>
              <ProtectedRoute path={"/CreateProductModal"} component={CreateProductModal} saveNavigationRoute={saveNavigationRoute}/>
              <ProtectedRoute path="/BatchDownloadTechSheets" component={BatchDownloadTechSheets}  saveNavigationRoute={saveNavigationRoute} />
              <UserRoute path="/Home" component={HomePageView} />
              <AdminRoute path="/Admin" component={AdminPageView} />
              <AgronomistRoute path="/Agronomist" component={AgronomistPageView} />
              <SuperUserRoute path="/SuperUser" component={SuperUserPageView} saveNavigationRoute={saveNavigationRoute}/>
              <SuperUserRoute path="/ManageAgronomyReferenceSheets" component={ManageAgronomyReferenceSheets}  saveNavigationRoute={saveNavigationRoute} />
              <SuperUserRoute path="/ManageProductLogos" component={ManageProductLogos}  saveNavigationRoute={saveNavigationRoute} />
              <SuperUserRoute path="/ManageBrandings" component={ManageBrandings}  saveNavigationRoute={saveNavigationRoute} />
              <SuperUserRoute path="/ManageComplimentaryLogos" component={ManageComplimentaryLogos}  saveNavigationRoute={saveNavigationRoute} />
              <SuperUserRoute path="/ManageCovers" component={ManageCovers}  saveNavigationRoute={saveNavigationRoute} />
              <SuperUserRoute path="/ManageCropCoverImages" component={ManageCropCoverImages}  saveNavigationRoute={saveNavigationRoute} />
              <SuperUserRoute path="/ManageDisclaimers" component={ManageDisclaimers}  saveNavigationRoute={saveNavigationRoute} />
              <SuperUserRoute path="/ManageFillerImages" component={ManageFillerImages}  saveNavigationRoute={saveNavigationRoute} />
              <SuperUserRoute path="/ManageFullPageCatalogImages" component={ManageFullPageCatalogImages}  saveNavigationRoute={saveNavigationRoute} />
              <SuperUserRoute path="/ManageSeedDividers" component={ManageSeedDividers}  saveNavigationRoute={saveNavigationRoute} />
              <SuperUserRoute path="/ManageShelfDividers" component={ManageShelfDividers} saveNavigationRoute={saveNavigationRoute} />
              <SuperUserRoute path="/ManageSeedIcons" component={ManageSeedIcons}  saveNavigationRoute={saveNavigationRoute} />
              <SuperUserRoute path="/ManageTaglines" component={ManageTaglines}  saveNavigationRoute={saveNavigationRoute} />
              <SuperUserRoute path="/ManageTechSheets" component={ManageTechSheets}  saveNavigationRoute={saveNavigationRoute} />
              <SuperUserRoute path="/ManagePostcardImages" component={ManagePostcardImages} saveNavigationRoute={saveNavigationRoute}/>
              <SuperUserRoute path="/ManagePosterImages" component={ManagePosterImages} saveNavigationRoute={saveNavigationRoute}/>
              <Route component={Login} />
            </Switch>
            <Loading />
            <DownloadInformer />
          </div>
        </ConnectedRouter>
      </Provider >
    );
  }
}

export { store, App };



// WEBPACK FOOTER //
// ./src/components/App/components/App.tsx